import { render, staticRenderFns } from "./directories.vue?vue&type=template&id=0af4fe16&"
import script from "./directories.vue?vue&type=script&lang=js&"
export * from "./directories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports